import { useEffect, useState } from "react";
import axios from "axios";
import API_URL from "../config/config";
import AdminSidebar from "../components/AdminSidebar";
import "../css/admin.css";

function AdminFlashSale() {

    const [flashSales, setFlashSales] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const [selectedImage, setSelectedImage] = useState(null);

    const [form, setForm] = useState({
        title: "",
        subtitle: "",
        discount_text: "",
        button_text: "",
        button_link: "",
        image: "",
        start_date: "",
        end_date: "",
        status: "Active"
    });

    useEffect(() => {
        loadFlashSales();
    }, []);

    const config = {
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
        }
    };

    // =============================
    // LOAD FLASH SALES
    // =============================

    const loadFlashSales = () => {

        axios
            .get(`${API_URL}/admin/flash-sales`, config)
            .then((res) => {
                setFlashSales(res.data);
            })
            .catch(console.log);

    };

    // =============================
    // HANDLE INPUT
    // =============================

    const handleChange = (e) => {

        setForm({
            ...form,
            [e.target.name]: e.target.value
        });

    };

    // =============================
    // IMAGE SELECT
    // =============================

    const handleImage = (e) => {

        setSelectedImage(e.target.files[0]);

    };

    // =============================
    // IMAGE UPLOAD
    // =============================

    const uploadImage = async () => {

        if (!selectedImage) {

            return form.image;

        }

        const data = new FormData();

        data.append("image", selectedImage);

        const res = await axios.post(
            `${API_URL}/upload`,
            data,
            {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            }
        );

        return res.data.image;

    };

    // =============================
    // SAVE FLASH SALE
    // =============================

    const saveFlashSale = async () => {

        try {

            const image = await uploadImage();

            const data = {
                ...form,
                image
            };

            if (editingId) {

                await axios.put(
                    `${API_URL}/admin/flash-sales/${editingId}`,
                    data,
                    config
                );

                alert("Flash Sale Updated");

            } else {

                await axios.post(
                    `${API_URL}/admin/flash-sales`,
                    data,
                    config
                );

                alert("Flash Sale Added");

            }

            setEditingId(null);
            setSelectedImage(null);
            setShowForm(false);

            setForm({
                title: "",
                subtitle: "",
                discount_text: "",
                button_text: "",
                button_link: "",
                image: "",
                start_date: "",
                end_date: "",
                status: "Active"
            });

            loadFlashSales();

        } catch (err) {

            console.log(err);

        }

    };

    // =============================
    // EDIT FLASH SALE
    // =============================

    const editFlashSale = (sale) => {

        setEditingId(sale.id);

        setForm({
            title: sale.title,
            subtitle: sale.subtitle,
            discount_text: sale.discount_text,
            button_text: sale.button_text,
            button_link: sale.button_link,
            image: sale.image,
            start_date: sale.start_date
                ? sale.start_date.substring(0, 10)
                : "",
            end_date: sale.end_date
                ? sale.end_date.substring(0, 10)
                : "",
            status: sale.status
        });

        setShowForm(true);

    };

    // =============================
    // DELETE FLASH SALE
    // =============================

    const deleteFlashSale = async (id) => {

        if (!window.confirm("Delete Flash Sale?"))
            return;

        await axios.delete(
            `${API_URL}/admin/flash-sales/${id}`,
            config
        );

        loadFlashSales();

    };    return (

        <div className="admin-layout">

            <AdminSidebar />

            <div className="admin-content">

                <h1>Flash Sale Management</h1>

                <button
                    className="edit-btn"
                    onClick={() => {

                        setEditingId(null);

                        setShowForm(!showForm);

                    }}
                >
                    {showForm ? "Close Form" : "Add Flash Sale"}
                </button>

                {showForm && (

                    <div className="edit-product-box">

                        <input
                            type="text"
                            name="title"
                            placeholder="Title"
                            value={form.title}
                            onChange={handleChange}
                        />

                        <textarea
                            name="subtitle"
                            placeholder="Subtitle"
                            value={form.subtitle}
                            onChange={handleChange}
                        />

                        <input
                            type="text"
                            name="discount_text"
                            placeholder="Discount Text"
                            value={form.discount_text}
                            onChange={handleChange}
                        />

                        <input
                            type="text"
                            name="button_text"
                            placeholder="Button Text"
                            value={form.button_text}
                            onChange={handleChange}
                        />

                        <input
                            type="text"
                            name="button_link"
                            placeholder="/shop"
                            value={form.button_link}
                            onChange={handleChange}
                        />

                        <label>Image</label>

                        <input
                            type="file"
                            onChange={handleImage}
                        />

                        {form.image && (

                            <img
                                src={`http://localhost:5000${form.image}`}
                                alt=""
                                width="180"
                                style={{ marginTop: 10 }}
                            />

                        )}

                        <label>Start Date</label>

                        <input
                            type="date"
                            name="start_date"
                            value={form.start_date}
                            onChange={handleChange}
                        />

                        <label>End Date</label>

                        <input
                            type="date"
                            name="end_date"
                            value={form.end_date}
                            onChange={handleChange}
                        />

                        <select
                            name="status"
                            value={form.status}
                            onChange={handleChange}
                        >
                            <option value="Active">
                                Active
                            </option>

                            <option value="Inactive">
                                Inactive
                            </option>
                        </select>

                        <button
                            className="edit-btn"
                            onClick={saveFlashSale}
                        >
                            {editingId
                                ? "Update Flash Sale"
                                : "Save Flash Sale"}
                        </button>

                    </div>

                )}

                <table className="admin-table">

                    <thead>

                        <tr>

                            <th>ID</th>

                            <th>Image</th>

                            <th>Title</th>

                            <th>Discount</th>

                            <th>Start</th>

                            <th>End</th>

                            <th>Status</th>

                            <th>Action</th>

                        </tr>

                    </thead>

                    <tbody>

                        {flashSales.map((sale) => (

                            <tr key={sale.id}>

                                <td>{sale.id}</td>

                                <td>

                                    {sale.image && (

                                        <img
                                            src={`http://localhost:5000${sale.image}`}
                                            alt=""
                                            width="120"
                                        />

                                    )}

                                </td>

                                <td>{sale.title}</td>

                                <td>{sale.discount_text}</td>

                                <td>
                                    {sale.start_date?.substring(0,10)}
                                </td>

                                <td>
                                    {sale.end_date?.substring(0,10)}
                                </td>

                                <td>{sale.status}</td>

                                <td>

                                    <button
                                        className="edit-btn"
                                        onClick={() => editFlashSale(sale)}
                                    >
                                        Edit
                                    </button>

                                    <button
                                        className="delete-btn"
                                        onClick={() => deleteFlashSale(sale.id)}
                                    >
                                        Delete
                                    </button>

                                </td>

                            </tr>

                        ))}

                    </tbody>

                </table>

            </div>

        </div>

    );

}

export default AdminFlashSale;